import { createAction, props} from '@ngrx/store';

export const changeUserType = createAction(
    '[User] Change User Type',
    props<{ userType: 'P' | 'C' | 'T' }>()
  );